import {
  MENUS_ITEMS_ROLE_VALUE_MENU_LIVE_IN_LA_BRESSE,
  MENUS_ITEMS_ROLE_VALUE_MENU_MY_CITY_HALL,
  MENUS_ITEMS_ROLE_VALUE_MENU_MY_PROCEDURES,
} from "@raiden/library/constants/menus/items";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";

export const MENU_HEADER_IMAGE_FALLBACK = generateFrontPath({
  id: "@front.internal-assets",
  parameters: { filePath: "header/vivre-a-la-bresse.png" },
  includeBasePath: true,
});

/** @type {Record<string, {src: string}>} */
export const MENU_HEADER_IMAGES = {
  [MENUS_ITEMS_ROLE_VALUE_MENU_LIVE_IN_LA_BRESSE]: {
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: { filePath: "header/vivre-a-la-bresse.png" },
      includeBasePath: true,
    }),
  },
  [MENUS_ITEMS_ROLE_VALUE_MENU_MY_CITY_HALL]: {
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: { filePath: "header/ma-mairie.png" },
      includeBasePath: true,
    }),
  },
  [MENUS_ITEMS_ROLE_VALUE_MENU_MY_PROCEDURES]: {
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: { filePath: "header/mes-demarches.png" },
      includeBasePath: true,
    }),
  },
};
